import { FC } from 'react';

import { Badge } from '@purpur/library';

import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { isEmpty } from '@telialt/utils/src/helpers';

import { BadgesColumn } from './Badges.styles';

type Props = {
    badges: string[];
};

export const Badges: FC<Props> = ({ badges }) => {
    if (isEmpty(badges)) {
        return null;
    }

    return (
        <BadgesColumn data-test={ESHOP_TEST_ID.BADGES_COLUMN}>
            {badges.map((badge, index) => (
                <Badge variant="information" showIcon={false} key={index + badge}>
                    {badge}
                </Badge>
            ))}
        </BadgesColumn>
    );
};
